import { render, staticRenderFns } from "./AddLoyalty.vue?vue&type=template&id=5e3e044f&scoped=true&"
import script from "./AddLoyalty.vue?vue&type=script&lang=js&"
export * from "./AddLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./AddLoyalty.vue?vue&type=style&index=0&id=5e3e044f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e044f",
  null
  
)

export default component.exports